import { extractMessage } from '@/helpers/errorHelper';

/**
 * Texto que ve la persona cuando el inicio de sesión falla.
 *
 * - 401/403: credenciales mal. No se muestra lo que diga el servidor, que
 *   puede revelar si el usuario existe o no.
 * - Sin respuesta (red caída, servidor apagado): no es culpa de sus datos.
 * - Cualquier otro error: el mensaje del servidor ya saneado.
 */
export const loginErrorMessage = (error) => {
    const status = error && error.response && error.response.status;
    if (status === 401 || status === 403) {
        return 'Usuario o contraseña incorrectos. Revisa tus datos e inténtalo de nuevo.';
    }
    if (!error || !error.response) {
        return 'No se pudo conectar con el servidor. Revisa tu conexión e inténtalo de nuevo.';
    }
    return extractMessage(error);
};
